import { Component, OnInit } from '@angular/core';
import { StoreService } from '../services/store.service';
import { IStats } from '../interfaces/stats';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  host: {'class': 'wrapper-dashboard'}
})
export class DashboardComponent implements OnInit {

  public tab = 1;
  public stats: IStats;
  public loading: boolean;
  public graphScreen: boolean = false;

  constructor(private _storeService: StoreService) {
    this.loading = true;
  }

  ngOnInit(): void {
    // this._storeService.stats().subscribe(data => {
    //   if (data['success']) {
    //     this.stats = data
    //     this.loading = false
        
    //     console.log(this.stats)

    //     let pi = 3.1415
    //     let c = 106 * pi * 2

    //     this.stats.payments['local_p_c'] = (this.stats.payments.local_p / 100) * c
    //     this.stats.payments['online_p_c'] = (this.stats.payments.online_p / 100) * c
    //   }
    // })
  }

  changeTab(tab) {
    this.tab = tab;
  }
  /**
   * Funcao que mostra/esconde tela de graficos
   */
  openCloseGraphScreen() {
    this.graphScreen = !this.graphScreen;
  }

}
